import CircularProgress from '@mui/material/CircularProgress'
import { styled } from '@mui/material/styles'

const LoadingRoot = styled('div')({
  position: 'absolute',
  top: '15%',
  left: '50%',
  transform: 'translateX(-50%)',
  textAlign: 'center',
})

const Loading = () => {
  return (
    <LoadingRoot>
      <CircularProgress />
    </LoadingRoot>
  )
}

export { Loading }
